import { Button, theme } from 'modules/ui';
import {
  NavigationAndActionFailLarge,
  NavigationAndActionSuccessLarge,
} from 'modules/ui/icons';
import React from 'react';
import {
  StyledSuccessActionContainer,
  StyledSuccessButtonContainer,
  StyledSuccessDescription,
  StyledSuccessIconContainer,
  StyledSuccessTitle,
} from './styled';

interface SuccessActionProps {
  success?: boolean;
  title: string;
  description?: string;
  buttonText?: string;
  successIcon?: React.ReactNode;
  failIcon?: React.ReactNode;
  successIconColor?: string;
  failIconColor?: string;
  onClick?: () => void;
}

export const SuccessAction: React.FC<SuccessActionProps> = ({
  success = true,
  title,
  description,
  buttonText,
  successIcon = <NavigationAndActionSuccessLarge />,
  failIcon = <NavigationAndActionFailLarge />,
  successIconColor = theme.colors.positive,
  failIconColor = theme.colors.negative,
  onClick,
}) => (
  <StyledSuccessActionContainer>
    <StyledSuccessIconContainer
      success={success}
      successIconColor={successIconColor}
      failIconColor={failIconColor}>
      {success ? successIcon : failIcon}
    </StyledSuccessIconContainer>
    <StyledSuccessTitle>{title}</StyledSuccessTitle>
    {description && (
      <StyledSuccessDescription>{description}</StyledSuccessDescription>
    )}
    {buttonText && (
      <StyledSuccessButtonContainer>
        <Button onClick={onClick} text={buttonText} />
      </StyledSuccessButtonContainer>
    )}
  </StyledSuccessActionContainer>
);
